import { Badge } from '@sravni/react-design-system/lib/Badge';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import type { LightweightCardBadgeSettings } from 'entities/Microcredits/ui/LightweightCard/types';
import { ServiceOneBadge } from 'entities/ServiceBanner/ui/ServiceOneBadge/ServiceOneBadge';

interface Args {
  offer: IClientMicrocreditListItem;
  hasUtmLabel: boolean;
  styles?: Record<string, string>;

  settings: Omit<LightweightCardBadgeSettings, 'visible'>;
}

export const getCardBadge = ({ offer, hasUtmLabel, styles, settings }: Args) => {
  const { isPartner, labelText } = offer?.advertising || {};
  const [advertisingLabel] = labelText?.split(';') || [];
  const seoLabel = offer?.seoLabel || '';

  const shouldShowSeoLabel = Boolean(seoLabel) && !hasUtmLabel && !settings.hideSeoBadge;
  const shouldShowAdvertisingLabel = Boolean(advertisingLabel) && !settings.hideAdvertisingBadge;
  const shouldShowPartnerBadge = Boolean(isPartner) && !settings.hidePartnerBadge;

  const isServiceOneBadge = offer?._features?.isSravniOffer;

  if (isServiceOneBadge) {
    return <ServiceOneBadge text={advertisingLabel} className={styles?.badge} />;
  }

  if (shouldShowPartnerBadge) {
    return <Badge color="orange" variant="primary" text="Mы рекомендуем" className={styles?.badge} />;
  }
  if (shouldShowAdvertisingLabel) {
    return <Badge color="blue" variant="primary" text={advertisingLabel} className={styles?.badge} />;
  }
  if (shouldShowSeoLabel) {
    return <Badge color="dark" variant="secondary" text={seoLabel} className={styles?.badge} />;
  }

  return null;
};
